import { render, staticRenderFns } from "./GeneralProblemHistory.vue?vue&type=template&id=5c720af2&scoped=true&lang=pug&"
import script from "./GeneralProblemHistory.vue?vue&type=script&lang=ts&"
export * from "./GeneralProblemHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c720af2",
  null
  
)

export default component.exports